// frontend/src/components/OrdersPage/OrderFinances/constants.js

export const BASE_URL = process.env.REACT_APP_DJANGO_BACKEND;

export const ORDER_FINANCES_API = `${BASE_URL}/api/order-finances/`;
export const ORDER_API_URL = `${BASE_URL}/api/orders/`;
export const ACCOUNTING_API = `${BASE_URL}/api/accounting/accounting-records/`;
export const SUPPLIER_PREPAYMENTS_API = `${BASE_URL}/api/accounting/supplier-prepayments/`;
export const COMMISSION_ALLOCATIONS_API = `${BASE_URL}/api/accounting/commission-allocations/`;
export const PROFIT_ALLOCATIONS_API = `${BASE_URL}/api/accounting/profit-allocations/`;
export const ACCOUNTS_API = `${BASE_URL}/api/finances/accounts/`;
export const CURRENCIES_API = `${BASE_URL}/api/accounting/currencies/`;

export const EMPTY_FACTORY_FORM = {
  factory_payment_date: "",
  factory_amount_cny: "",
  factory_payment_via: "",
  factory_comment: "",
  factory_proof: null,
};

export const FACTORY_FIELDS = [
  "factory_payment_date",
  "factory_amount_cny",
  "factory_payment_via",
  "factory_comment",
];

export const PAYMENT_STATUS_OPTIONS = [
  { value: "PAID", label: "Оплачен" },
  { value: "PENDING", label: "Не оплачен" },
];